import { memo } from 'react'
import styled from 'styled-components'
import { ScreenQuery } from '../../utilities'
import {
  CompanyHighlight,
  CompanyHighlightCard,
} from './company-highlight-card'

type Props = {
  data: CompanyHighlight[]
}
export const Container = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.sizes.spacings.xxxxxl}px`} 0 300px;
  gap: ${({ theme }) => `${theme.sizes.spacings.xl}px`};
  ${ScreenQuery.mobile} {
    flex-direction: column;
    width: 60%;
  }
  ${ScreenQuery.tablet} {
    flex-direction: column;
    width: 40%;
  }
`

export const CompanyHighlights = memo(({ data }: Props) => {
  return (
    <Container>
      {data.map((highlight) => (
        <CompanyHighlightCard key={highlight?.name} data={highlight} />
      ))}
    </Container>
  )
})

CompanyHighlights.displayName = 'CompanyHighlights'
